module.exports = __webpack_public_path__ + "static/logo-og-3d4fd09a8f0e7c3ecfce98986310466e.png";